import React, { useEffect, useState } from "react";
import { Container, Row, Col, Accordion, Card } from "react-bootstrap";
import Rellax from "rellax";
import { AiOutlineDownload } from "react-icons/ai";
import profile from "../../Assets/klean-leaf-profile.pdf";
import catalog from "../../Assets/klean_leaf_catalog.pdf";
import Techstack from "./Techstack";
import claw from "../../Assets/factory_1-png.webp";
import boy from "../../Assets/factory_3.webp";
import stuffy from "../../Assets/factory_2-png.webp";
import bubbles from "../../Assets/bubbles.png";
import basket from "../../Assets/basket-bg.png";
import hanger from "../../Assets/clothes-hanger.png";
import kleanleaf from "../../Assets/kleanleaf.png";
import Seo, { breadcrumbSchema, faqSchema, organizationSchema } from "../Seo/Seo";

const aboutFaqs = [
  {
    question: "What is Klean Leaf?",
    answer: "Klean Leaf is a Columbus, Ohio based B2B private-label laundry detergent sheet manufacturer helping brands launch custom laundry sheet products.",
  },
  {
    question: "Who does Klean Leaf help?",
    answer: "Klean Leaf helps brands, wholesalers, refill shops, e-commerce brands, subscription brands, retailers, distributors, and eco-home product companies.",
  },
  {
    question: "What is the minimum order quantity (MOQ)?",
    answer: "MOQ starts at 1,000 retail package units per SKU. Bulk refill cartons are available separately for refill shops and wholesale programs.",
  },
  {
    question: "Where are Klean Leaf products manufactured?",
    answer: "Products are manufactured in Guangdong, China. North American business operations, customer service, sample support, and logistics coordination are handled through Columbus, Ohio.",
  },
  {
    question: "Are your products certified for quality and safety?",
    answer: "Available documentation includes ISO 9001, ISO 22716 GMP, OECD 301B, MSDS, and optional third-party testing support.",
  },
  {
    question: "What private label support do you offer?",
    answer: "Support can include manufacturing, custom packaging, formula and scent direction, artwork integration, logistics, and delivery coordination.",
  },
];
function About() {
  const [activeKey, setActiveKey] = useState("0");

  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  // Initialize Rellax (parallax effect)
  useEffect(() => {
    // Check if elements with the class 'rellax' exist before initializing Rellax
    const elements = document.querySelectorAll('.rellax');
    if (elements.length > 0) {
      const rellax = new Rellax('.rellax');
  
      // Cleanup function to destroy the instance if it exists
      return () => {
        if (rellax && typeof rellax.destroy === 'function') {
          rellax.destroy();
        }
      };
    }
  }, []);

  return (
    <Container fluid className="about-section page-top-settings" id="about">
      <Seo
        title="Private Label Laundry Detergent Manufacturer"
        description="Meet Klean Leaf, a Columbus, Ohio supported private label laundry care manufacturer with detergent sheet factory, documents, and logistics support."
        path="/about"
        schema={[
          organizationSchema,
          breadcrumbSchema([{ name: "Home", path: "/" }, { name: "About", path: "/about" }]),
          faqSchema(aboutFaqs),
        ]}
      />

      <div className="background-wrapper">
        <img src={bubbles} alt="Laundry detergent bubbles" className="rellax background1" data-rellax-speed="7" />
        <img src={hanger} alt="Laundry care hanger icon" className="rellax background2" data-rellax-speed="-4" />
        <img src={basket} alt="Laundry basket background" className="rellax background4" data-rellax-speed="6" />
        <img src={kleanleaf} alt="Klean Leaf product mark" className="rellax background5" data-rellax-speed="8" />
      </div>

      <Container className="about-content white">
        <Row style={{ textAlign: "center" }}>
          <h1>Private Label Laundry Detergent Manufacturer</h1>
          <h2 className="page-title center">
            About Klean Leaf
            <p>Columbus, Ohio support for private label laundry sheet buyers</p>
          </h2>
        </Row>
        <Row className="hero-section">
          <Col md={7} className="hero-text">
            <h2>Detergent Sheet Manufacturing for Business Buyers</h2>
            <p>
            Klean Leaf works with brands, wholesalers, refill shops, distributors, retailers, and e-commerce teams that want to launch or source laundry detergent sheets under their own brand. Our Columbus, Ohio team supports sampling, communication, and logistics coordination while our manufacturing partners handle formulation, production, and packaging.
            </p>
              
            <a
              className="secondary-btn"
              href={profile}
              style={{ maxWidth: "350px" }}
              target="_blank"
              rel="noreferrer"
            >
              <AiOutlineDownload />
              &nbsp; Klean Leaf Profile
            </a>

            <a
              className="secondary-btn"
              href={catalog}
              style={{ maxWidth: "350px" }}
              target="_blank"
              rel="noreferrer"
            >
              <AiOutlineDownload />
              &nbsp; Catalog
            </a>
        
          </Col>
          <Col md={5} className="hero-image">
            <img className="feature-icon" src={claw} alt="Laundry detergent sheet factory equipment" />
          </Col>
        </Row>

        {/* Features Section with Accordion */}
        
        <Row className="features-section">
          <Col md={12} className="features-title"><h2>Frequently Asked Questions</h2></Col>
          <Col md={5} className="features-image">
            <img className="feature-team" src={boy} alt="Laundry detergent sheet production team" />
          </Col>
          <Col md={7}>
            <Accordion activeKey={activeKey}>
              <Card>
                <Accordion.Header onClick={() => handleToggle("8")}>
                  <span>Q: What is Klean Leaf?</span>
                </Accordion.Header>
                <Accordion.Collapse eventKey="8">
                  <Card.Body>
                    <p>
                      A: Klean Leaf is a Columbus, Ohio based B2B private-label laundry detergent sheet manufacturer helping brands launch custom laundry sheet products.
                    </p>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>

              <Card>
                <Accordion.Header onClick={() => handleToggle("9")}>
                  <span>Q: Who does Klean Leaf help?</span>
                </Accordion.Header>
                <Accordion.Collapse eventKey="9">
                  <Card.Body>
                    <p>
                      A: Klean Leaf helps brands, wholesalers, refill shops, e-commerce brands, subscription brands, retailers, distributors, and eco-home product companies.
                    </p>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>

            <Card>
                <Accordion.Header onClick={() => handleToggle("6")}>
                  <span>Q: Can you produce sheets without any PVA?</span>
                </Accordion.Header>
                <Accordion.Collapse eventKey="6">
                  <Card.Body>
                    <p>
                      A: Our R&D team has successfully developed a PVA-free formulation, but we’re not at large-scale production yet. We’re working hard on ramping up volume capacity and will keep all clients updated as soon as full PVA-free sheets become widely available.
                    </p>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>

              <Card>
                <Accordion.Header onClick={() => handleToggle("7")}>
                  <span>Q: Why does my sample sheet feel less smooth than other suppliers’ sheets?</span>
                </Accordion.Header>
                <Accordion.Collapse eventKey="7">
                  <Card.Body>
                    <p>
                      A: We intentionally minimize PVA content to maximize cleaning power and eco-credentials. If you prefer an ultra-smooth finish, we can add more PVA to match that texture—just let us know, and we’ll customize your next batch accordingly.
                    </p>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>


              <Card>
                <Accordion.Header onClick={() => handleToggle("0")}>
                  <span>Q: What is the minimum order quantity (MOQ)?</span>
                </Accordion.Header>
                <Accordion.Collapse eventKey="0">
                  <Card.Body>
                    <p>
                      A: MOQ starts at 1,000 retail package units per SKU. Bulk refill cartons are available separately for refill shops and wholesale programs.
                    </p>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>

              <Card>
                <Accordion.Header onClick={() => handleToggle("1")}>
                  <span>Q: Where are Klean Leaf products manufactured?</span>
                </Accordion.Header>
                <Accordion.Collapse eventKey="1">
                  <Card.Body>
                    <p>
                      A: Products are manufactured in Guangdong, China. North American business operations, customer service, sample support, and logistics coordination are handled through Columbus, Ohio.
                    </p>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            
              <Card>
                <Accordion.Header onClick={() => handleToggle("2")}>
                  <span>Q:Are your products certified for quality and safety?</span>
                </Accordion.Header>
                <Accordion.Collapse eventKey="2">
                  <Card.Body>
                    <p>
                      A: Available documentation can include ISO 9001, ISO 22716 GMP, OECD 301B, MSDS, and optional third-party testing support.
                    </p>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>

              <Card>
                <Accordion.Header onClick={() => handleToggle("3")}>
                  <span>Q: What are the available packaging options?</span>
                </Accordion.Header>
                <Accordion.Collapse eventKey="3">
                  <Card.Body>
                    <p>
                      A: We offer paper bags, paper boxes, custom packaging, and bulk refill cartons. Packaging can be planned around your brand, channel, and pack count.
                    </p>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>

              <Card>
                <Accordion.Header onClick={() => handleToggle("4")}>
                  <span>Q: Do you offer sample packs?</span>
                </Accordion.Header>
                <Accordion.Collapse eventKey="4">
                  <Card.Body>
                    <p>
                      A: Yes. Sample support is available from the Columbus, Ohio office so buyers can review sheet performance, scent, and packaging direction.


                    </p>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>

              <Card>
                <Accordion.Header onClick={() => handleToggle("5")}>
                  <span>Q: What support do you offer for private label clients?</span>
                </Accordion.Header>
                <Accordion.Collapse eventKey="5">
                  <Card.Body>
                    <p>
                      A: Klean Leaf supports private label manufacturing, custom packaging, formula and scent development, samples, production, and logistics support.
                    </p>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>

            </Accordion>
          </Col>
        </Row>

        <div className="integration-section">
          <Container>
            <Row>
              <Col className="primary">
                <h2 className="skewed">Certified for Quality and Safety</h2>
                <p>
                  Our available documentation includes ISO 9001, ISO 22716 GMP, OECD 301B, MSDS, and optional third-party testing support. These documents help business buyers evaluate product quality, safety information, and compliance needs before launch.
                </p>
              </Col>
            </Row>
          </Container>
        </div>

        <Row className="hero-section">
          <Col md={7} className="hero-text">
            <h2>Laundry Care Manufacturing and Logistics Support</h2>
            <p>
            Our manufacturing network supports production, research and development, packaging, and order coordination for private label laundry sheet programs. Typical lead time is around 35 to 45 days after order confirmation, depending on formula, packaging, testing, and shipment requirements.
            </p>
            <a
              className="secondary-btn"
              href={profile}
              target="_blank"
              rel="noreferrer"
            >
              <AiOutlineDownload />
              &nbsp; Klean Leaf Profile
            </a>

            <a
                className="secondary-btn"
                href={catalog}
                target="_blank"
                rel="noreferrer"
              >
                <AiOutlineDownload />
                &nbsp; Catalog
            </a>
          </Col>
          <Col md={5} className="hero-image">
            <img className="feature-icon" src={stuffy} alt="Private label laundry detergent sheet manufacturing facility" />
          </Col>
        </Row>

        <h2 className="about-heading">Build Your Laundry Sheet Program with Klean Leaf</h2>
        <Techstack />
      </Container>
    </Container>
  );
}

export default About;
